import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { ButtonToolbar, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { FormSection, reduxForm, Field } from 'redux-form';
import validate from './Validate';
import Select from '../../../shared/components/form/Select';
import renderField from '../../../shared/components/form/RenderField';
import TextAreaField from '../../../shared/components/form/TextAreaField';
import RangeDateSelection from '../../../shared/components/form/RangeDateSelectionField';

const ClassPlanForm = (props) => {
  const {
    t,
    backHandler,
    dto,
    recipients,
    subjects,
    bnccs,
    initialize,
    handleSubmit,
  } = props;

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.classes-names')}
        </span>
        <div className="form_form-group-field">
          <Field
            name="recipients"
            isMulti
            closeMenuOnSelect={false}
            component={Select}
            options={recipients}
            placeholder={t('general.placeholders.select')}
          />
        </div>
      </div>
      <FormSection name="planHeader" className="form__section">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.discipline')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="subject"
              component={Select}
              options={subjects}
              placeholder={t('general.placeholders.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.date')}</span>
          <div className="form_form-group-field">
            <Field
              name="rangeDate"
              component={RangeDateSelection}
              months={2}
              def={dto.planHeader.rangeDate}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.theme')}</span>
          <div className="form_form-group-field">
            <Field
              name="theme"
              component={renderField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.general-objective')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="generalObjective"
              component={renderField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.contents')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="contents"
              component={TextAreaField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.procedures-taken')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="procedureTaken"
              component={TextAreaField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.resources-used')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="resources"
              component={TextAreaField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.evaluation')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="evaluation"
              component={TextAreaField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.bncc-skills')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="bnccSkills"
              isMulti
              closeMenuOnSelect={false}
              component={Select}
              options={bnccs}
              placeholder={t('general.placeholders.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.general-observations')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="generalObservation"
              component={TextAreaField}
              placeholder={t('general.placeholders.type-here')}
            />
          </div>
        </div>
      </FormSection>
      <ButtonToolbar className="form__button-toolbar">
        <Button color="primary" onClick={backHandler}>
          {t('general.back')}
        </Button>
        <Button color="success" type="submit">
          {t('general.save')}
        </Button>
      </ButtonToolbar>
    </form>
  );
};

ClassPlanForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  subjects: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  recipients: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  bnccs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

export default reduxForm({
  form: 'ClassPlanForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(ClassPlanForm));
